import { useSuspense } from "@api";
import type { CERStatus } from "@bbj-types/candidate/cerstatus";
import type { IDocument } from "@bbj-types/document";
import type { IUser } from "@bbj-types/user";
import type { ObjectId } from "@bbj-types/utils";
import type { IDateRange } from "@styleguide";
import { useCallback } from "react";
import { axiosCandidateInstanceV2, axiosV2 } from "./axios";

export interface ICerQuery {
  authors?: string[];
  status?: string[];
  statusExcluded?: string[];
  period?: IDateRange;
}

export interface IUseGetCer {
  author: Pick<IUser, "firstName" | "lastName" | "_id">;
  createdAt: Date;
  document: IDocument;
  _id: ObjectId;
  type: string;
  candidate: ObjectId;
  signatureComment?: string;
  toDiscuss?: boolean;
}
export type TValidationDrawerCerResponse = Partial<Record<CERStatus, IUseGetCer[]>>;

export const useGetCer = () => {
  const [state, execute, cancel] = axiosV2<TValidationDrawerCerResponse, ICerQuery, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: ICerQuery) => {
      return execute({
        url: "/v2/candidate/cer",
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetCerSuspense = (params: ICerQuery) => {
  return useSuspense(
    () =>
      axiosCandidateInstanceV2.get<TValidationDrawerCerResponse>("/cer", {
        withCredentials: true,
        params,
      }),
    [params]
  );
};
